export const CUSTOM_PLANS = {
  free: {
    basePrice: 0,
    additionalUserPrice: 15,
    additionalProfilePrice: 10
  },
  base: {
    basePrice: 89,
    additionalUserPrice: 10,
    additionalProfilePrice: 0.3
  },
  team: {
    basePrice: 159,
    additionalUserPrice: 20,
    additionalProfilePrice: 0.25
  }
}
